import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuelidate from 'vuelidate'

import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueSvgGauge from 'vue-svg-gauge' 
Vue.use(VueSvgGauge)

import ECharts from 'vue-echarts' // refers to components/ECharts.vue in webpack
 

// import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/gauge'
import 'echarts/lib/component/polar'
Vue.component('v-chart', ECharts)

import KProgress from 'k-progress';
Vue.component('k-progress', KProgress);

import ProgressBar from 'vuejs-progress-bar'
Vue.use(ProgressBar)

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false

Vue.use(Vuelidate);

new Vue({
  router,
  components: {
    'app': App
  },
  render: h => h(App),
}).$mount('#app')
